module.exports = __webpack_public_path__ + "static/fonts/Sansation-Regular-webfont.758433c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sansation/Sansation-Regular-webfont.woff
// module id = mwqj
// module chunks = 0